import { default as BaseModal } from "@ds-developer/modal";
import { BookingConflictTable } from "@hubcapp/components/Calendar/components/Modals/AddLessonModal/components/BookingConflictTable";
import { Box, makeStyles } from "@material-ui/core";
import { TimeSlot } from "@hubcapp/types";
import Button from "@ds-developer/button";
import CloseIcon from "@material-ui/icons/Close";
import IconButton from "@material-ui/core/IconButton";
import React from "react";

const useStyles = makeStyles(theme => ({
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
}));

interface Props {
  backPreviewBookingModalHandler: () => void;
  loadingTimeSlots?: boolean;
  cancelPendingLessonsLoading?: boolean;
  createEventLoading?: boolean;
  handleCreatePreBookedLessons: () => void;
  handleCancel: () => void;
  bookedTimeSlots: TimeSlot[] | undefined;
  timeSlotsAvailability?: { timeSlotsAvailability: TimeSlot[] } | undefined;
  repeatingLessonFrequencyNumber?: number | null;
}

export const BookingPreviewModal: React.FC<Props> = ({
  backPreviewBookingModalHandler,
  loadingTimeSlots,
  cancelPendingLessonsLoading,
  createEventLoading,
  handleCreatePreBookedLessons,
  bookedTimeSlots,
  timeSlotsAvailability,
  repeatingLessonFrequencyNumber,
  handleCancel,
}) => {
  const classes = useStyles();
  const actions = (
    <>
      <Button
        variant="outlined"
        onClick={backPreviewBookingModalHandler}
        loading={loadingTimeSlots || cancelPendingLessonsLoading}
      >
        Back
      </Button>
      <Button
        variant="contained"
        color="primary"
        onClick={handleCreatePreBookedLessons}
        form="previewBookingForm"
        disabled={bookedTimeSlots?.length === 0}
        loading={
          createEventLoading || loadingTimeSlots || cancelPendingLessonsLoading
        }
      >
        {`Add ${bookedTimeSlots?.length ?? 0} lessons`}
      </Button>
    </>
  );

  return (
    <BaseModal actions={actions} open={true} title="Booking preview">
      <IconButton
        aria-label="close"
        className={classes.closeButton}
        onClick={async () => {
          await backPreviewBookingModalHandler();
          await handleCancel();
        }}
      >
        <CloseIcon />
      </IconButton>
      <form id="previewBookingForm" onSubmit={e => e.preventDefault()}>
        <Box marginBottom={3}>
          <BookingConflictTable
            timeSlots={timeSlotsAvailability?.timeSlotsAvailability}
            loadingTimeSlots={loadingTimeSlots}
            repeatingLessonFrequencyNumber={repeatingLessonFrequencyNumber}
          />
        </Box>
      </form>
    </BaseModal>
  );
};
